import Layout from "./components/Layout/Layout";

import {Route, Routes} from 'react-router-dom'
import HomePage from "./pages/HomePage";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DepartmentPage from "./pages/DepartmentPage";
import ProductsPage from "./pages/ProductsPage";
import ProductPage from "./pages/ProductPage";
import LoginPage from "./pages/LoginPage";
import {useAuthStore} from "./store/user-store";
import RegisterPage from "./pages/RegisterPage";
import {useEffect, useState} from "react";
import {baseApi} from "./api/axios";
import OrderPage from "./pages/OrderPage";
import BalancePage from "./pages/BalancePage";
import ProfilePage from "./pages/ProfilePage";
import OnlinePage from "./pages/OnlinePage";
import AppOnlinePage from "./pages/AppOnlinePage";
import OrderOnlinePage from "./pages/OrderOnlinePage";
import BanksPage from "./pages/BanksPage";
import ChargesPage from "./pages/ChargesPage";
import AboutPage from "./pages/AboutPage";
import VipPage from "./pages/VipPage";
import NotificationsPage from "./pages/NotificationsPage";
import BankDetailesPage from "./pages/BankDetailesPage";

export default function App() {
    const authStore = useAuthStore()
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const getSettings = async () => {
        setLoading(true)
        try {
            const response = await baseApi('/settings');
            authStore.setSettings(response.data?.settings)
            setShowModal(response.data?.settings?.notification?.title != null);

            if (response.data?.user?.id) {
                localStorage.setItem('user', JSON.stringify(response.data?.user))
                authStore.setUser(response.data?.user)

            }
        } catch (e) {
            toast.error('خطأ في الدخول للموقع يرجى تحديث الصفحة'+e)
        }
        setLoading(false)
    }

    const closeModal = () => {
        setShowModal(false)
    }
    useEffect(() => {
        getSettings()
    }, [])

    return (
        <main data-theme={'dark'} className={`${authStore.gradient ? 'bg-gradient-main' : 'bg-color'}`}>
            <Layout>
                <ToastContainer/>


                <div className={`modal fade ${showModal == true ? 'show' : ''} `} id="exampleModal"
                     style={{display: `${showModal == true ? 'block' : 'none'}`}} tabIndex="-1"
                     aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="btn-close" dataBsDismiss="modal"
                                        ariaLabel="Close" onClick={closeModal}></button>
                            </div>
                            <div className="modal-body">
                                <h2>{authStore.settings?.notification?.title}</h2>
                                {authStore.settings?.notification?.img!=null ?  <div className="p-1 rounded bg-dark">
                                   {/* <img className={'img-modal '} src={authStore.settings?.notification?.img} alt=""/>*/}
                                </div> :null}

                                {authStore.settings?.notification?.body}
                                {authStore.settings?.notification?.url !==''?  <a href={authStore.settings?.notification?.url}>{authStore.settings?.notification?.url}</a> :null}

                            </div>
                            <div className="modal-footer text-center">
                                <button className="btn btn-sm btn-outline-success" onClick={closeModal}>موافق</button>
                            </div>

                        </div>
                    </div>
                </div>


                <main>
                    <Routes>
                        <Route index element={<HomePage/>}/>
                        <Route path={'/categories/:id'} element={<DepartmentPage/>}/>
                        <Route path={'/departments/:id'} element={<ProductsPage/>}/>
                        <Route path={'/products/:id'} element={<ProductPage/>}/>
                        <Route path={'/about'} element={<AboutPage/>}/>
                        <Route path={'/pricing'} element={<VipPage/>}/>
                        {authStore.user == null ? <Route path={'/login'} element={<LoginPage/>}/> : null}
                        {authStore.user == null ? <Route path={'/register'} element={<RegisterPage/>}/> : null}
                        {authStore.user?.name ? <Route path={'/payments'} element={<BanksPage/>}/> : null}
                        {authStore.user?.name ? <Route path={'/payments/:id'} element={<BankDetailesPage/>}/> : null}
                        {authStore.user?.name ? <Route path={'/charges'} element={<ChargesPage/>}/> : null}
                        {authStore.user?.name ? <Route path={'/orders'} element={<OrderPage/>}/> : null}
                        {authStore.user?.name ? <Route path={'/balances'} element={<BalancePage/>}/> : null}
                        {authStore.user?.name ? <Route path={'/profile'} element={<ProfilePage/>}/> : null}
                        {authStore.user?.name ? <Route path={'/notifications'} element={<NotificationsPage/>}/> : null}
                        {authStore.online === true ? <Route path={'/online'} element={<OnlinePage/>}/> : null}
                        {authStore.online === true ? <Route path={'/online/:id'} element={<AppOnlinePage/>}/> : null}
                        {authStore.online === true ? <Route path={'/invoices'} element={<OrderOnlinePage/>}/> : null}
                        <Route path={'*'} element={<span className={'text-white fs-1'}>الصفحة غير موجودة</span>}/>
                    </Routes>

                </main>

            </Layout>
        </main>
    );
}


